import { SiteRFPSummariesSortByParam } from '@black-bear-energy/black-bear-energy-common'

interface ColumnMetadata {
  title: string
  width: number
  sortKey?: SiteRFPSummariesSortByParam
}

export const SITES_COLUMNS: ColumnMetadata[] = [
  {
    title: 'Site Name',
    width: 28,
    sortKey: SiteRFPSummariesSortByParam.SiteName,
  },
  {
    title: 'Project Name',
    width: 25,
    sortKey: SiteRFPSummariesSortByParam.CustomerRFPName,
  },
  { title: 'Size', width: 10, sortKey: SiteRFPSummariesSortByParam.SystemSize },
  {
    title: 'Array Location',
    width: 15,
    sortKey: SiteRFPSummariesSortByParam.ArrayLocation,
  },
  { title: 'Phase', width: 15, sortKey: SiteRFPSummariesSortByParam.Phase },
  {
    title: 'Construction',
    width: 16,
    sortKey: SiteRFPSummariesSortByParam.ConstructionStartDate,
  },
  { title: 'COD', width: 16 },
]
